import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"


const initialState = { status: null, loading: false, data: [], error: "", message: '' }


export const rewardLastWeekAction = createAsyncThunk(
    'reward-last-week',
    async (data, { rejectWithValue }) => {
        try {
            console.log("data", data)
            // const res = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/no-of-quit-attempts`)
            const res = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/user-earned-last-week/${data.date}/${data.days}`)

            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const rewardLastWeekSlice = createSlice({
    name: 'reward-last-week',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(rewardLastWeekAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(rewardLastWeekAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(rewardLastWeekAction.rejected, (state, action) => {
                state.loading = false
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.error = action?.payload?.message
            })
        },

})



export const  rewardLastWeekReducer = rewardLastWeekSlice.reducer